import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import StatusBullet from '../../../../components/StatusBullet';
import { useStyles } from './FiliadoRegisterVisitasStyles';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import Alert from '@material-ui/lab/Alert';
import moment from 'moment';
import { getVisitaFiliado } from '../../../../services/VisitaFiliadoService';
import { Values } from '../../../../values/Values';

export default function FiliadoRegisterVisitas(props) {
  const {
    filiado,
    setFiliado,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    filiacaoStatus,
    gruposSanguineos,
    edicao,
    history,
    setLoading
  } = props;
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [refreshState, setRefreshState] = useState(new Date());


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function onMouseOveRowTable(event, index) {
    filiado.visitas[index].on_mouse_over = true;
    setRefreshState(new Date());
  }

  function onMouseLeaveRowTable(event, index) {
    filiado.visitas[index].on_mouse_over = false;
    setRefreshState(new Date());
  }

  async function goToVisitaFiliado(index) {
    try {
      if (filiado.visitas[index].visitaEncerrada) {
        setLoading(true);
        const visitaCompleta = await getVisitaFiliado(filiado.visitas[index]);
        if (visitaCompleta.isSuccess) {
          setLoading(false);
          if (visitaCompleta.result.length > 0) {
            history.push('/visita-filiado-preview/', { visitaFiliado: visitaCompleta.result[0] });
          }
          else {
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack(Values.MessageValues.erro_catch);
            setShowMessageSnack(true);
          }
        } else {
          setLoading(false);
          setTypeSnack('warning');
          setMessageSnack(visitaCompleta.message);
          setShowMessageSnack(true);
        }
      } else {
        history.push('/visita-filiado-edit-detalhado/', { visitaFiliado: filiado.visitas[index], edicao: true });
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  return (
    filiado.visitas && filiado.visitas.length <= 0 ?
      <Alert severity="warning">FILIADO AINDA NÃO POSSUI NENHUMA VISITA AO CLUBE</Alert>
      :
      <div>
        <Paper className={classes.root}>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell
                    key={'dataEntrada'}
                    align={'left'}
                  >
                    Data Entrada
                  </TableCell>
                  <TableCell
                    key={'dataSaida'}
                    align={'left'}
                  >
                    Data Saida
                  </TableCell>
                  <TableCell
                    key={'status'}
                    align={'left'}
                  >
                    Status
                  </TableCell>
                  <TableCell
                    key={'valorGasto'}
                    align={'left'}
                  >
                    Valor Gasto
                  </TableCell>
                  <TableCell
                    key={'actions'}
                    align={'left'}
                  >

                  </TableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                {filiado.visitas && filiado.visitas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((visita, index) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                      onMouseOver={event => onMouseOveRowTable(event, index)}
                      onMouseLeave={event => onMouseLeaveRowTable(event, index)}
                    >
                      <TableCell>
                        {!visita.dataEntrada ? 'Não informado' : moment(visita.dataEntrada).format('DD/MM/YYYY HH:mm')}
                      </TableCell>
                      <TableCell>
                        {!visita.dataSaida ? 'Não informado' : moment(visita.dataSaida).format('DD/MM/YYYY HH:mm')}
                      </TableCell>
                      <TableCell>
                        <div className={classes.statusContainer}>
                          <StatusBullet
                            className={classes.status}
                            color={!visita.visitaEncerrada ? 'success' : 'danger'}
                            size="sm"
                          />
                          {!visita.visitaEncerrada ? 'Em andamento' : 'Encerrada'}
                        </div>
                      </TableCell>
                      <TableCell>
                        {`R$ ${(visita.valorTotal ? visita.valorTotal : 0).toFixed(2)}`}
                      </TableCell>
                      <TableCell
                        align={'right'}
                        style={{width: '20%'}}

                      >
                        <Box
                          component={'div'}
                          display={'inline'}
                          visibility={visita.on_mouse_over ? 'visible' : 'hidden'}
                        >
                          <Tooltip title="Ir para detalhamento da visita">
                            <IconButton
                              aria-label="linkVisita"
                              onClick={e => goToVisitaFiliado(index)}
                            >
                              <OpenInNewIcon
                                color = 'action'
                                fontSize='small'
                              />
                            </IconButton>
                          </Tooltip>

                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={filiado.visitas ? filiado.visitas.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Paper>
      </div>


  );
}
